import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import { Periods, convertPeriodToRange } from '@/models/StandardReport'

const state = {
  loading: false,
  period: Periods.CURRENT_MONTH,
  calendarRange: convertPeriodToRange(Periods.TODAY),
  selectedInsertionOrderIds: null,
  selectedBillingPeriodIds: null,
  insertionOrders: [],
  // null参照を防ぐため、初期値をもたせておく
  reportData: {
    columns: [],
    count: 0,
    data: [],
    pageNo: 0,
    status: '',
  },
  // null参照を防ぐため、初期値をもたせておく
  dailyReportData: {
    columns: [],
    count: 0,
    data: [],
    pageNo: 0,
    status: '',
  },
  campaignReportData: {}, // 案件ごとのキャンペーンレポートデータ
  campaigns: {}, // 案件ごとのキャンペーンリスト
  deliveryGroupReportData: {}, // キャンペーンごとの配信グループレポートデータ
  // キャンペーンごとの選択されたBudgetId
  // `${campaignId}`: [1, 2]
  selectedCampaignBudgetIds: {},
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
